export const WORDS = [
  'loona',
  'gowon',
  'apple',
  'birds',
  'world',
  'earth',
  'paint',
  'dance',
  'color',
  'paint',
  'heart',
  'vivid',
  'carol',
  'plane',
  'paris',
  'tokyo',
  'dance',
  'wings',
  'fairy',
  'light',
  'front',
  'hyeju',
  'jiwoo',
  'yerim',
  'month',
  'moons',
  'peach',
  'orbit',
  'voice',
  'night',
  'stars',
  'dream',
  'shine',
  'space',
  'betta',
  'japan',
  'seoul',
  'flash',
  'fruit',
  'music',
 ]
